import { render } from "./fullscreenVideo.vue?vue&type=template&id=54556e2c"
import script from "./fullscreenVideo.vue?vue&type=script&lang=js"
export * from "./fullscreenVideo.vue?vue&type=script&lang=js"

import "./fullscreenVideo.vue?vue&type=style&index=0&id=54556e2c&lang=scss"

import exportComponent from "C:\\Users\\clha\\Documents\\Development\\interflon-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__